module.exports = {
  "tx-111": {
    "identifierType": "PORTAL_ID",
    "maxAge": 86400000,
    "parameters": {
      "extension": [
        "control",
        "extend",
        "30days"
      ]
    }
  }
};